import {
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
  LOAD_WISHLIST,
} from "../types/Wishlist.types";

const initialState = {
  items: [],
};

const WishlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_WISHLIST:
      if (state.items.some((item) => item.id === action.payload.id)) {
        return state;
      }
      return { ...state, items: [...state.items, action.payload] };
    case REMOVE_FROM_WISHLIST:
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.payload),
      };
    case LOAD_WISHLIST:
      return { ...state, items: action.payload };
    default:
      return state;
  }
};

export default WishlistReducer;
